<template>
  <div>

    <h1 :id="categoryId()" class="tm" v-show="((products && products.length) || hasChildren())"
        v-waypoint="waypointParams(isLast)">
      {{ category.level === 0 && !category.is_not_deleted ? category.name : '' }}
      <template
        v-if="category.work_time && category.work_time.is_working_now === false && category.work_time.to !== null && category.work_time.from !== null">
        <template v-if="category.level !== 0"> {{ category.name }}</template>
        <span
          style="color: darkgray; font-size: 14px">{{ category.work_time.from }} – {{ category.work_time.to }}</span>
      </template>
    </h1>

    <ul class="tovar_list" v-if="$store.getters.outletSettings.delivery_type !== 4"
        :class="{'tl_line tl_small': imagesStyle === IMAGES_SQUARE_MINIATURE}">
      <ProductItem
        v-for="(product, index) in products"
        :key="index"
        :category="category" :product="product"
      />
    </ul>
    <ul class="tovar_list" v-else :class="{'tl_line tl_small': imagesStyle === IMAGES_SQUARE_MINIATURE}">
      <ResourceItem
        v-for="(product, index) in products"
        :key="index"
        :category="category" :product="product"
      />
    </ul>
  </div>
</template>

<script>
  import * as moment from 'moment'
  import ProductItem from '@/components/Default/ProductItem'
  import {mapGetters} from 'vuex'
  import {ADD_TO_PRODUCTS, SET_FILTER, SET_SELECTED_CATEGORY} from '@/store/mutations.type'
  import {FETCH_PRODUCTS, SELECT_CATEGORY} from '@/store/actions.type'
  import ResourceItem from '@/components/Default/Resource/ResourceItem'

  export default {
    name: 'ProductBlock',
    components: {
      ResourceItem,
      ProductItem
    },
    props: [
      'category',
      'isLast',
      'prefix'
    ],
    data() {
      return {
        products: [],
        stickOptions: {
          options: {
            offset_top: 50
          }
        }
      }
    },
    mounted() {
      this.getProducts()

      this.$store.subscribe((mutation) => {
        if (mutation.type === ADD_TO_PRODUCTS) {
          this.getProducts()
        }
      })
      this.$store.subscribe((mutation) => {
        if (mutation.type === SET_FILTER) {
          this.getProducts()
        }
      })

    },
    methods: {
      hasChildren() {
        for (let i in this.$store.getters.categories) {
          if (this.$store.getters.categories[i].parent_id === this.category.id) {
            return true
          }
        }
        return false
      },
      waypointParams(isLast) {
        if (isLast) {
          return {active: true, callback: this.onWaypoint, options: {rootMargin: '0% 0% -70% 0%'}}
        } else {
          return {active: true, callback: this.onWaypoint, options: {rootMargin: '0% 0% -80% 0%'}}
        }
      },
      categoryId() {
        return this.prefix + this.category.id
      },

      onWaypoint({going, direction}) {
        if (going === this.$waypointMap.GOING_IN) {
          this.select()
        }
        if (going === this.$waypointMap.GOING_OUT && direction === this.$waypointMap.DIRECTION_BOTTOM) {
          if (this.$store.getters.selectedCategory[this.category.level].current.id === this.category.id) {
            this.select(true)
          }
        }
      },

      select(previous = false) {
        if (previous) {
          this.$store.dispatch(SELECT_CATEGORY, {
            category: this.$store.getters.selectedCategory[this.category.level].previous,
            categories: this.getSiblings(this.category),
            level: this.category.level,
            selectLastChildren: true,
            ignoreBlock: this.category.level && this.category.parent_id === this.$store.getters.selectedCategory[this.category.level - 1].previous.id
          })
        } else {
          this.$store.dispatch(SELECT_CATEGORY, {
            category: this.category,
            categories: this.getSiblings(this.category),
            level: this.category.level,
            ignoreBlock: this.category.level && this.category.parent_id === this.$store.getters.selectedCategory[this.category.level - 1].current.id
          })
        }
      },

      getSiblings(category) {
        let siblings = []
        for (let i in this.$store.getters.categories) {
          if (this.$store.getters.categories[i].parent_id === category.parent_id) {
            siblings.push(this.$store.getters.categories[i])
          }
        }
        return siblings
      },

      getProducts() {
        this.products = []
        if (this.category.id === 0) {
          this.$store.getters.products.forEach(element => {
            if (element.is_top === 1) {
              this.products.push(element)
            }
          })
        } else {
          this.$store.getters.products.forEach(element => {
            if (element.category_id === this.category.id && this.filtered(element)) {
              this.products.push(element)
            }
          })
        }
        this.products.sort((a, b) => a.priority > b.priority ? 1 : -1)
      },

      filtered(product) {
        if (this.$store.getters.outletSettings.delivery_type !== 4) {

        } else {
          if (this.$store.getters.filter.date.start !== null && this.$store.getters.filter.date.end !== null) {
            let filterStart = moment(this.$store.getters.filter.date.start).utcOffset(this.$store.getters.outletSettings.timezone_offset).hour(0).format('YYYY-MM-DD')
            let filterEnd = moment(this.$store.getters.filter.date.end).utcOffset(this.$store.getters.outletSettings.timezone_offset).hour(0).format('YYYY-MM-DD')
            for (let i in product.times) {
              let time = moment(product.times[i].date).format('YYYY-MM-DD')
              if (product.times[i].available && (filterStart <= time && filterEnd >= time)) {
                return true
              }
            }
            return false
          }

        }

        return true
      }
    },
    computed: {
      productsLoaded() {
        return this.$store.getters.status[FETCH_PRODUCTS]
      },
      ...mapGetters(['imagesStyle', 'IMAGES_SQUARE_MINIATURE'])
    }
  }
</script>
